var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPpixicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65561",
    "data-name": "Grupo 65561",
    transform: "translate(-792 -988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15498",
    "data-name": "Ret\\xE2ngulo 15498",
    transform: "translate(792 988)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65551",
    "data-name": "Grupo 65551",
    transform: "translate(4107 6567.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94715",
    "data-name": "Caminho 94715",
    d: "M110.64,836.282a.951.951,0,0,1-1.221.548,6.775,6.775,0,0,0-2.368-.424h-1.423a6.7,6.7,0,0,0-6.732,6.656.948.948,0,0,1-1.9,0,8.59,8.59,0,0,1,8.628-8.531h1.423a8.676,8.676,0,0,1,3.036.544A.933.933,0,0,1,110.64,836.282Zm2-9.954a6.4,6.4,0,1,1-6.4-6.328A6.372,6.372,0,0,1,112.645,826.328Zm-1.9,0a4.5,4.5,0,1,0-4.5,4.453A4.484,4.484,0,0,0,110.748,826.328Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94716",
    "data-name": "Caminho 94716",
    d: "M115.492,837.328a2.81,2.81,0,0,1,2.936,2.656,2.594,2.594,0,0,1-.823,1.891,2.768,2.768,0,0,1-1.168.664v.523a.948.948,0,0,1-1.9,0v-.552a9.308,9.308,0,0,1-1.63-.467.933.933,0,0,1-.531-1.217.951.951,0,0,1,1.231-.525,6.728,6.728,0,0,0,2.084.465.832.832,0,0,0,.837-.782c0-.423-.476-.781-1.04-.781a2.83,2.83,0,0,1-3.084-2.656,2.667,2.667,0,0,1,2.133-2.6v-.634a.948.948,0,0,1,1.9,0v.723a8.406,8.406,0,0,1,1.242.378.933.933,0,0,1,.54,1.213.951.951,0,0,1-1.227.534,4.976,4.976,0,0,0-1.906-.394.782.782,0,0,0-.782.781C114.3,837,114.8,837.328,115.492,837.328Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPpixicon);
export default __webpack_public_path__ + "static/media/LPpixicon.ea6540eae23455bf6d42c59e72ff7023.svg";
export { ForwardRef as ReactComponent };